import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Authority() {
  const bullets = ['Más de 8 años especializados en ecommerce', 'Experiencia directa con negocios retail y productos físicos', 'Enfoque en estructura, conversión y operación comercial', 'Desarrollo de sistemas ecommerce profesionales', 'Visión comercial, no solo técnica'];
  return <section className="relative py-16 md:py-24 bg-navy-950 text-white overflow-hidden border-y border-white/5" data-id="element-18">
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-950 to-navy-950" data-id="element-19"></div>
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-accent/15 blur-[150px] rounded-full" data-id="element-20"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-12 text-center max-w-4xl mx-auto" data-id="element-22">
          Un ecommerce no se construye como una pieza aislada.{' '}
          <span className="text-accent" data-id="element-23">Se construye como sistema.</span>
        </h2>

        <div className="grid md:grid-cols-12 gap-10 items-center" data-id="element-24">
          <div className="md:col-span-5 relative" data-id="element-25">
            <div className="absolute inset-0 bg-accent/30 blur-[80px] rounded-full" data-id="element-26"></div>
            <div className="relative rounded-3xl overflow-hidden border-2 border-accent/40 shadow-glow-lg" data-id="element-27">
            </div>
          </div>

          <div className="md:col-span-7" data-id="element-28">
            <h3 className="text-3xl font-heading font-bold text-accent mb-1" data-id="element-29">
              Nicolás Riquelme
            </h3>
            <p className="text-slate-400 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-30">
              Fundador · Bitzen eCommerce
            </p>

            <div className="space-y-6 text-lg text-slate-300 font-light leading-relaxed mb-8" data-id="element-31">
              <p data-id="element-32">
                Soy Nicolás Riquelme, fundador de Bitzen eCommerce. Durante más
                de 8 años he trabajado desarrollando tiendas online, estructuras
                ecommerce, automatizaciones comerciales y estrategias de
                conversión para negocios de productos físicos.
              </p>
              <p className="font-medium text-white border-l-4 border-accent pl-4" data-id="element-33">
                Mi foco no es vender diseño web. Mi foco es ayudar a dueños de
                pymes retail a lanzar un canal de ventas online con criterio
                comercial, estructura operativa y visión de crecimiento.
              </p>
            </div>

            <div className="space-y-3" data-id="element-34">
              {bullets.map((bullet, i) => <div key={i} className="flex items-start gap-3" data-id="element-35">
                  <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-1" data-id="element-36" />
                  <span className="text-slate-300" data-id="element-37">{bullet}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}